<template>
  <div class="centered-blocks-list row-3-custom p-top-9 p-bot-6">
    <div>
      <div class="centered-blocks-list-container">
        <h1 class="title-medium3 is-medium-bold" v-html="props.title" />
        <div class="centered-blocks-list-wrap">
          <div v-for="(entry, index) in news" :key="index">
            <NuxtLink
              :to="
                localePath({
                  name: 'news-slug',
                  params: { slug: entry.slug },
                })
              "
            >
              <div
                class="centered-blocks-list"
                :class="{ 'no-margin-bottom': index === news.length - 1 }"
              >
                <div class="centered-blocks-list__text">
                  <div class="centered-blocks-list__text__content">
                    <h2 class="title-base3" v-html="entry.title" />
                    <div class="text-medium" v-html="entry.introNews"></div>
                  </div>
                </div>
                <div class="centered-blocks-list__image">
                  <div
                    v-if="
                      entry.sezioneContenutoPagina?.length &&
                      entry.sezioneContenutoPagina[0].custom?.length
                    "
                  >
                    <WidgetPicture
                      :image="{
                        custom: entry.sezioneContenutoPagina[0].custom[0],
                      }"
                      :alt="entry.sezioneContenutoPagina[0].custom[0]?.title"
                    />
                  </div>
                </div>
              </div>
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  news: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: '',
  },
})
</script>

<script>
export default {
  name: 'CenteredBlocksList',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
